import React from "react";
import {
  Container,
  Item,
  Header,
  CircleIndicator,
  Title,
  Description,
} from "../../common/CommonStyles";
import styled from "styled-components";
import { COLORS } from "../../../../../../../../assets/constants/styles";

export const CandidateQuestionsRenderer = ({
  questions,
  bestMatchIndex = -1,
  explanation,
  t,
}) => {
  if (!questions || !Array.isArray(questions) || questions.length === 0)
    return null;

  return (
    <div>
      <CandidateTitle>{t("logs.candidateQuestions")}:</CandidateTitle>
      <Container>
        {questions.map((question, index) => {
          const isMatched = index === bestMatchIndex;
          return (
            <Item key={index}>
              <Header isHighlighted={isMatched}>
                <CircleIndicator isHighlighted={isMatched}>
                  {index}
                </CircleIndicator>
                <Title isHighlighted={isMatched}>{question}</Title>
              </Header>
              {isMatched && explanation && (
                <ExplanationText>{explanation}</ExplanationText>
              )}
            </Item>
          );
        })}
      </Container>
    </div>
  );
};

const CandidateTitle = styled.h4`
  margin: 0 0 12px 0;
  font-size: 15px;
  font-weight: 600;
  color: ${COLORS.black};
`;

const ExplanationText = styled(Description)`
  font-style: italic;
`;
